<div class="statusControl" (clickOutside)="close()">
  <button
    #trigger
    type="button"
    class="statusTrigger"
    [class.is-open]="isOpen"
    [attr.data-tone]="selectedTone"
    [attr.aria-expanded]="isOpen"
    [attr.aria-controls]="isOpen ? panelId : null"
    aria-haspopup="menu"
    (click)="toggle()"
    (keydown.arrowDown)="openFromKeyboard($event)"
    (keydown.arrowUp)="openFromKeyboard($event)"
  >
    <span class="statusTrigger__icon">
      <span class="bk-sym" aria-hidden="true">{{ triggerIcon }}</span>
    </span>
    <span class="statusTrigger__text">
      <span class="statusTrigger__label">{{ label }}</span>
      <span class="statusTrigger__value">
        <span class="statusTrigger__dot" [attr.data-tone]="selectedTone"></span>
        <span class="statusTrigger__valueText">{{ selectedTitle }}</span>
      </span>
    </span>
    <span class="bk-sym statusTrigger__chevron" aria-hidden="true">expand_more</span>
  </button>

  @if (isOpen) {
    <div
      class="statusPanel"
      role="menu"
      [id]="panelId"
      [attr.aria-label]="label"
      [class.align-right]="panelAlign === 'right'"
      [style.width]="panelWidth"
      (keydown)="onPanelKeydown($event)"
    >
      <p class="statusPanel__heading" aria-hidden="true">{{ label }}</p>
      @for (option of options; track option.value) {
        <button
          type="button"
          role="menuitemradio"
          tabindex="-1"
          [attr.aria-checked]="isActive(option)"
          [attr.data-tone]="option.tone ?? 'neutral'"
          class="statusPanel__option"
          [class.is-active]="isActive(option)"
          (click)="select(option.value)"
        >
          <span class="statusPanel__optionIcon">
            <span class="bk-sym" aria-hidden="true">{{ option.icon }}</span>
          </span>
          <span class="statusPanel__optionTitle">{{ option.title }}</span>
          <span
            class="statusPanel__dot"
            [attr.data-tone]="option.tone ?? 'neutral'"
          ></span>
          @if (isActive(option)) {
            <span class="bk-sym statusPanel__check" aria-hidden="true">check_circle</span>
          }
        </button>
      }
    </div>
  }
</div>
